const serveMap: { [key: string]: any } = {
  localhost: 'SEA',
  test: 'SEA',
  sea: 'SEA',
  ind: 'IND',
  us: 'US',
};
const defaultServeLang: { [key: string]: any } = {
  SEA: {
    name: "SG_en",
    serve: "SEA",
    region: "SG",
    id: 18
  },
  IND: {
    name: "IND_ms",
    serve: "IND",
    region: "IND",
    id: 12
  },
  US: {
    name: "NA_en",
    serve: "US",
    region: "NA",
    id: 32
  }
}
const defaultLang: { [key: string]: any } = {
  ME: {
    id: 15,
    defaultRegionLang: "ME_ar",
    name: "ME_ar",
    serve: "SEA"
  },
  BR: {
    id: 13,
    defaultRegionLang: "BR_pt-br",
    serve: "US"
  },
  SAC: {
    id: 31,
    defaultRegionLang: "SAC_es",
    serve: "US"
  },
  VN: {
    id: 3,
    defaultRegionLang: "VN_vn",
    serve: "SEA"
  },
  SG: {
    id: 18,
    defaultRegionLang: "SG_en",
    serve: "SEA"
  },
  RU: {
    id: 7,
    defaultRegionLang: "RU_ru",
    serve: "SEA"
  },
  IND: {
    id: 12,
    defaultRegionLang: "IND_ms",
    serve: "IND"
  },
  TW: {
    id: 2,
    defaultRegionLang: "TW_zh-tw",
    serve: "SEA"
  },
  TH: {
    id: 4,
    defaultRegionLang: "TH_th",
    serve: "SEA"
  },
  US: {
    id: 26,
    defaultRegionLang: "US_es",
    serve: "US"
  },
  ID: {
    id: 6,
    defaultRegionLang: "ID_ind",
    serve: "SEA"
  },
  EUROPE: {
    id: 1,
    defaultRegionLang: "EUROPE_en",
    serve: "SEA"
  },
  NA: {
    id: 33,
    defaultRegionLang: "NA_es",
    serve: "US"
  },
  PK: {
    id: 11,
    defaultRegionLang: "PK_fa",
    serve: "SEA"
  },
  ZA: {
    id: 23,
    defaultRegionLang: "ZA_en",
    serve: "SEA"
  },
  BD: {
    id: 44,
    defaultRegionLang: "BD_en",
    serve: "SEA"
  }
}

const regionMap: { [key: string]: any } = {
  SG: {
    default: 'en',
    other: [],
    name: {
      en: 'SG(English)',
    },
  },
  RU: {
    default: 'ru',
    other: [],
    name: {
      ru: 'RU(Pусский)',
    },
  },
  TW: {
    default: 'zh-tw',
    other: ['ja', 'ko'],
    name: {
      'zh-tw': 'TW(繁體中文)',
      ja: 'TW(日本語)',
      ko: 'TW(한국어)',
    },
  },
  TH: {
    default: 'th',
    other: ['en', 'my'],
    name: {
      th: 'TH(ภาษาไทย)',
      en: 'TH(English)',
      my: 'TH(ျမန္မာ)',
    },
  },
  VN: {
    default: 'vn',
    other: [],
    name: {
      vn: 'VN(Tiếng Việt)',
    },
  },
  ID: {
    default: 'ind',
    other: [],
    name: {
      ind: 'ID(Bahasa Indonesia)',
    },
  },
  PK: {
    default: 'fa',
    other: ['ur'],
    name: {
      fa: 'PK(English)',
      ur: 'PK(اردو)',
    },
  },
  ZA: {
    default: 'en',
    other: [],
    name: {
      en: 'ZA(English)',
    },
  },
  BD: {
    default: 'en',
    other: ['bn'],
    name: {
      en: 'BD(English)',
      bn: 'BD(বাংলা)',
    },
  },
  ME: {
    default: 'ar',
    other: ['en'],
    name: {
      ar: 'ME(عربى)',
      en: 'ME(English)',
    },
  },
  EUROPE: {
    default: 'en',
    other: ['tr'],
    name: {
      en: 'EU(English)',
      tr: 'EU(Türkçe)',
    },
  },
  NA: {
    default: 'es',
    other: ['en'],
    name: {
      es: 'NA(Español)',
      en: 'NA(English)',
    },
  },
  BR: {
    default: 'pt-br',
    other: [],
    name: {
      'pt-br': 'BR(Português)',
    },
  },
  SAC: {
    default: 'es',
    other: [],
    name: {
      es: 'SAC(Español)',
    },
  },
  US: {
    default: 'es',
    other: [],
    name: {
      es: 'US(Español)',
    },
  },
  IND: {
    default: 'ms',
    other: ['hi'],
    name: {
      ms: 'IND(English)',
      hi: 'IND(हिंदी)',
    },
  },
};
export { serveMap, defaultServeLang, defaultLang, regionMap };
